<template>
    <div class="folder-management">
        <div v-if="dmMessageMode === 'group'" class="section">
            <div class="line">
                <div class="field-item">
                    <div class="lable_item">メッセージ区分</div>
                    <div class="item-group">
                        <div class="w-100">
                            <ans-input
                                id="Keyword"
                                v-model="data.searchFolder.Keyword"
                                type="text"
                                :max-length="100"
                                placeholder="グループ名で検索"
                                item-class="width-400-px"
                                is-enable-i-m-e
                                input-class="custom-border"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="line">
                <div class="field-item mt-10-px">
                    <div class="lable_item">フォルダ区分</div>
                    <div class="item-group">
                        <div class="w-100">
                            <ans-radio-button
                                id="BoxType"
                                :customizeWrapperClass="{ 'flex-wrap': true }"
                                v-model="data.searchFolder.BoxType"
                                :options="options.BoxType"
                                :is-horizontal="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="line">
                <div class="field-item mt-10-px">
                    <div class="lable_item">メッセージ区分</div>
                    <div class="item-group">
                        <div class="w-100">
                            <ans-radio-button
                                id="MessageType"
                                :customizeWrapperClass="{ 'flex-wrap': true }"
                                v-model="data.searchFolder.MessageType"
                                :options="options.MessageType"
                                :is-horizontal="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="line mt-10-px">
                <div class="field-item">
                    <div class="lable_item">使用区分</div>
                    <div class="item-group mt-7-px">
                        <ans-switch id="ActiveFLG" :isShowCheckbox="true" wrapper-input-class="height-30-px" v-model="data.searchFolder.ActiveFLG" />
                    </div>
                </div>
            </div>
            <div class="toolbar mt-10-px justify-content-end">
                <button class="search-btn" @click="$emit('search-folder')">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <path
                            d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                        ></path>
                    </svg>
                </button>
                <button class="clear-btn" @click="data.searchFolder.Keyword = ''">クリア</button>
            </div>

            <div class="p-20 v-card v-sheet v-sheet--outlined theme--light mt-3">
                <div class="detail mx-0 mt-2">
                    <div class="table-scroll">
                        <table class="main-table table-list table-bordered table-width align-table">
                            <thead>
                                <tr>
                                    <th class="text-center width-50-px" @click="$emit('open-detail', '')">
                                        <i class="fa-solid fa-plus cursor-pointer"></i>
                                    </th>
                                    <th class="text-center min-width-250-px">フォルダ名</th>
                                    <th class="text-center width-100-px">並順</th>
                                    <th class="text-center width-100-px">フォルダ区分</th>
                                    <th class="text-center width-100-px">メッセージ区分</th>
                                    <th class="text-center width-100-px">メンバー数</th>
                                    <th class="text-center width-100-px">操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="data.listFolder.length > 0">
                                    <tr v-for="(item, index) in normalizedFolders" :key="item.FolderID || item.No || index">
                                        <td class="text-start">
                                            <span class="staff-id">{{ item.No }}</span>
                                        </td>
                                        <td class="text-start">{{ item.FolderName }}</td>
                                        <td class="text-center">{{ item.LineNo }}</td>
                                        <td class="text-center">{{ item.BoxTypeName }}</td>
                                        <td class="text-center">{{ item.MessageTypeName }}</td>
                                        <td class="text-center">{{ item.MemberCount }}</td>
                                        <td class="text-center">
                                            <span class="edit mr-10-px" @click="$emit('open-detail', item)"><i class="fa-solid fa-pencil"></i></span>
                                            <span class="delete" @click="$emit('delete-folder', item)"><i class="fa-solid fa-trash"></i></span>
                                        </td>
                                    </tr>
                                </template>
                                <tr v-else class="msg_no_data">
                                    <td colspan="7" class="text-center">該当するデータが存在しません。</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="section">
            <div class="field-item">
                <div class="lable_item">フォルダ名</div>
                <div class="item-group">
                    <div class="w-100">
                        <ans-input
                            id="FolderName"
                            v-model="data.folderDetail.FolderName"
                            type="text"
                            placeholder="例: グループA"
                            :max-length="50"
                            :isEnableIME="true"
                            input-class="custom-border"
                            is-required
                        />
                    </div>
                </div>
            </div>
            <div class="field-item mt-10-px">
                <div class="lable_item">並び順</div>
                <div class="item-group">
                    <div class="w-25">
                        <ans-input v-model="data.folderDetail.LineNo" type="number" :max-length="2" input-class="custom-border" is-disabled />
                    </div>
                </div>
            </div>
            <div class="field-item mt-10-px">
                <div class="lable_item">フォルダ区分</div>
                <div class="item-group">
                    <div class="w-100">
                        <ans-radio-button
                            id="BoxType"
                            :customizeWrapperClass="{ 'flex-wrap': true }"
                            v-model="data.folderDetail.BoxType"
                            :options="options.BoxType"
                            :is-horizontal="true"
                        />
                    </div>
                </div>
            </div>
            <div class="field-item mt-10-px">
                <div class="lable_item">メッセージ区分</div>
                <div class="item-group">
                    <div class="w-100">
                        <ans-radio-button
                            id="MessageType"
                            :customizeWrapperClass="{ 'flex-wrap': true }"
                            v-model="data.folderDetail.MessageType"
                            :options="options.MessageType"
                            :is-horizontal="true"
                            :on-change="
                                () => {
                                    $emit('change-type-folder');
                                }
                            "
                        />
                    </div>
                </div>
            </div>
            <div class="line mt-10-px">
                <div class="field-item">
                    <div class="lable_item">使用区分</div>
                    <div class="item-group mt-7-px">
                        <ans-switch id="ActiveFLG" :isShowCheckbox="true" wrapper-input-class="height-30-px" v-model="data.folderDetail.ActiveFLG" />
                    </div>
                </div>
            </div>

            <div class="line-border-bottom mt-20-px"><label class="control-label">メンバー</label></div>

            <MemberTableInternal
                v-if="isInternalMessageType"
                @add-new-member="$emit('add-new-member')"
                @delete-member="$emit('delete-member', $event)"
                @move-up="$emit('move-up', $event)"
                @move-down="$emit('move-down', $event)"
                @refer-employee="forwardReferEmployee"
                @get-employee-name="forwardGetEmployeeName"
            />

            <MemberTableExternal
                v-else
                @add-new-member="$emit('add-new-member')"
                @delete-member="$emit('delete-member', $event)"
                @move-up="$emit('move-up', $event)"
                @move-down="$emit('move-down', $event)"
                @refer-md="forwardReferMD"
                @get-md-name="forwardGetMDName"
                @refer-client="forwardReferClient"
                @get-client-name="forwardGetClientName"
                @refer-branch="forwardReferBranch"
                @get-branch-name="forwardGetBranchName"
                @refer-user="forwardReferUser"
                @get-user-name="forwardGetUserName"
            />

            <div class="footer-actions">
                <ans-button label="キャンセル" class="clear-btn" style="width: 110px !important" @click="$emit('back-list')" />
                <ans-button label="保存" class="search-btn" @click="submitGroup" style="width: 60px !important" :is-disabled="!canSubmitFolder" />
            </div>
        </div>
    </div>
</template>

<script>
import AnsSwitch from '@/components/ansSwitch/index.vue';
import MemberTableInternal from './MemberTableInternal.vue';
import MemberTableExternal from './MemberTableExternal.vue';
import { mapMutations, mapState } from 'vuex';
import { MSG_TITLE, MSG_TYPE } from '@/utils/messages';

export default {
    name: 'FolderManagementSection',
    components: { AnsSwitch, MemberTableInternal, MemberTableExternal },
    data() {
        return {
            errors: []
        };
    },
    computed: {
        ...mapState('app', ['user', 'isShowLeftMenu', 'dmMessageMode']),
        ...mapState('MNG_DM_Message_Store', ['data', 'options']),
        isInternalMessageType() {
            return String(this.data.folderDetail.MessageType) == '0';
        },
        normalizedFolders() {
            return (this.data.listFolder || []).map((item) => ({
                ...item,
                BoxTypeName: item.BoxType == 1 ? '送信' : '受信',
                MessageTypeName: item.MessageType == 1 ? '社外' : '社内'
            }));
        },

        canSubmitFolder() {
            const folder = { ...this.data?.folderDetail };
            if (!folder) return false;

            const folderName = String(folder.FolderName || '').trim();
            if (!folderName) return false;

            const members = Array.isArray(folder.members) ? folder.members : [];
            if (members.length === 0) return false;

            const messageType = String(folder.MessageType);

            if (messageType == '0') {
                return members.every((member) => String(member?.EmployeeCD || '').trim());
            }

            if (messageType == '1') {
                return members.every(
                    (member) =>
                        String(member?.MDCD || '').trim() &&
                        String(member?.ClientCD || '').trim() &&
                        String(member?.BranchCD || '').trim() &&
                        String(member?.UserID || '').trim()
                );
            }

            return false;
        }
    },
    methods: {
        ...mapMutations('app', ['showModalMessage', 'hideModalMessage']),
        forwardReferEmployee(index, value, item) {
            this.$emit('refer-employee', index, value, item);
        },
        forwardGetEmployeeName(value, item) {
            this.$emit('get-employee-name', value, item);
        },
        forwardReferMD(index, value, item) {
            this.$emit('refer-md', index, value, item);
        },
        forwardGetMDName(value, item) {
            this.$emit('get-md-name', value, item);
        },
        forwardReferClient(index, value, item) {
            this.$emit('refer-client', index, value, item);
        },
        forwardGetClientName(value, item) {
            this.$emit('get-client-name', value, item);
        },
        forwardReferBranch(index, value, item) {
            this.$emit('refer-branch', index, value, item);
        },
        forwardGetBranchName(value, item) {
            this.$emit('get-branch-name', value, item);
        },
        forwardReferUser(index, value, item) {
            this.$emit('refer-user', index, value, item);
        },
        forwardGetUserName(value, item) {
            this.$emit('get-user-name', value, item);
        },
        validateFolderDuplicate() {
            const folder = this.data?.folderDetail;
            if (!folder || !Array.isArray(folder.members)) return;

            const members = folder.members;
            const messageType = String(folder.MessageType);
            const duplicateMap = new Map();

            this.errors = this.errors.filter((e) => {
                const name = e?.name || '';
                return !(
                    name.startsWith('EmployeeCD') ||
                    name.startsWith('MDCD') ||
                    name.startsWith('ClientCD') ||
                    name.startsWith('BranchCD') ||
                    name.startsWith('UserID')
                );
            });

            members.forEach((member, index) => {
                if (messageType == '0') {
                    const emp = String(member?.EmployeeCD || '').trim();
                    if (!emp) return;

                    if (!duplicateMap.has(emp)) {
                        duplicateMap.set(emp, [index]);
                    } else {
                        duplicateMap.get(emp).push(index);
                    }
                }

                if (messageType == '1') {
                    const mdcd = String(member?.MDCD || '').trim();
                    const clientCD = String(member?.ClientCD || '').trim();
                    const branchCD = String(member?.BranchCD || '').trim();
                    const userID = String(member?.UserID || '').trim();

                    if (!mdcd || !clientCD || !branchCD || !userID) return;

                    const key = `${mdcd}|${clientCD}|${branchCD}|${userID}`;

                    if (!duplicateMap.has(key)) {
                        duplicateMap.set(key, [index]);
                    } else {
                        duplicateMap.get(key).push(index);
                    }
                }
            });

            duplicateMap.forEach((indexes) => {
                if (indexes.length <= 1) return;

                indexes.forEach((idx) => {
                    if (messageType == '0') {
                        this.errors.push({
                            name: 'EmployeeCD' + idx,
                            message: '重複しています。'
                        });
                    }

                    if (messageType == '1') {
                        ['MDCD', 'ClientCD', 'BranchCD', 'UserID'].forEach((field) => {
                            this.errors.push({
                                name: field + idx,
                                message: '重複しています。'
                            });
                        });
                    }
                });
            });
        },
        submitGroup() {
            this.validateFolderDuplicate();
            if (this.errors.length > 0) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.S001,
                    content: '社員コードが重複しています。',
                    okText: 'OK',
                    callback: () => {
                        document.getElementById(this.errors[0].name).focus();
                    }
                });
                return;
            }
            this.$emit('submit');
        }
    }
};
</script>
